import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The workspace agent panel collapses to minimized',
  name: 'agent_panel_minimized',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
